/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Type of dictionary
 * @export
 * @enum {string}
 */

export const DictionaryTypeDto = {
    UniversityName: 'UNIVERSITY_NAME',
    Location: 'LOCATION',
    TypeOfStudy: 'TYPE_OF_STUDY',
    Status: 'STATUS',
    YearOfStudy: 'YEAR_OF_STUDY'
} as const;

export type DictionaryTypeDto = typeof DictionaryTypeDto[keyof typeof DictionaryTypeDto];



